import { createSelector } from 'reselect';
import { createGeneralSelectors } from '../_common/selectors';

const getProductCategorySlice = state => state.productCategory;
export const { getById, getIds } = createGeneralSelectors(getProductCategorySlice);

export const getProductCategoryList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));

export const getProductCategoryByProductId = (state, productId) => getProductCategoryList(state).filter(elem => elem.ProductId === productId);
